var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.user.role === 'admin')?_c('AdminDashboard'):(_vm.user.role === 'builder')?_c('BuilderDashboard'):(_vm.user.role === 'support')?_c('SupportDashboard'):(_vm.user.role !== 'support')?_c('PlatformDashboard'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }